import { reactive, computed } from 'vue'
import { setLocale } from '@/i18n'

const LOCALE_KEY = 'obra_locale'

export const SUPPORTED_LOCALES = [
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'ko', label: '한국어', flag: '🇰🇷' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
] as const

export type LocaleCode = 'pt' | 'en' | 'es' | 'de' | 'fr' | 'it' | 'zh' | 'ja' | 'ko' | 'ru' | 'nl'

const state = reactive({
  current: (localStorage.getItem(LOCALE_KEY) || 'pt') as LocaleCode,
})

export const localeStore = {
  state,
  current: computed(() => state.current),
  set(code: LocaleCode) {
    state.current = code
    setLocale(code)
  },
  init() {
    const stored = localStorage.getItem(LOCALE_KEY) as LocaleCode | null
    if (stored && SUPPORTED_LOCALES.some(l => l.code === stored)) {
      state.current = stored
      setLocale(stored)
    }
  },
}
